import { useBeaconlistStore } from 'contexts/RootStore.context';
import { Horizontal } from 'gls';
import { observer } from 'mobx-react';
import { headerStyle } from 'styling/App.style';
import CategorySearchSelect from 'components/inputs/Select/CategorySearchSelect/CategorySearchSelect';
import { Select } from 'components/inputs/Select/Select';

export const HeaderSearch = observer(() => {
  const {
    setSearchTerm,
    setSearchCategory,
    loadBeacons,
    searchCategoriesList,
    AssignmentSearchOptions,
    assignFilter,
    setAssignFilter
  } = useBeaconlistStore();

  const onSearch = (search: string, category: string) => {
    setSearchTerm(search)
    setSearchCategory(category)
    return loadBeacons(true)
  }

  return (
    <Horizontal className={headerStyle} spacing={10}>
      <CategorySearchSelect
        onSearch={onSearch}
        placeholder='Search for beacons'
        searchCategoriesList={searchCategoriesList}
      />
      <Select
        id="enable-search-select"
        options={AssignmentSearchOptions}
        onChange={(value) => {
          setAssignFilter(value)
          setSearchTerm("")
          setSearchCategory("")
          loadBeacons(true)
        }}
        value={assignFilter}
        height='40px'
      />
    </Horizontal>
  );
})
